import React from 'react';
import SEO from '../../../../components/SEO/SEO';
import { Link } from 'react-router-dom';
import './SEOSaaS.css';

const SEOSaaS = () => {
    const saasSeoServices = [
        {
            id: 'technical-seo',
            icon: '⚙️',
            title: 'Technical SEO for SaaS',
            description: 'Optimize your software platform for search engines with technical SEO audits, site speed optimization, and crawlability improvements.',
            link: '/services/seo/technical-seo'
        },
        {
            id: 'content-marketing',
            icon: '📝',
            title: 'Content Marketing for SaaS',
            description: 'Create valuable content that attracts your target audience, builds authority, and drives organic trial sign-ups.',
            link: '/services/seo/on-page'
        },
        {
            id: 'keyword-research',
            icon: '🎯',
            title: 'Keyword Research for Software',
            description: 'Target the right keywords that your ideal customers are searching for when looking for software solutions.',
            link: '/services/seo/on-page'
        },
        {
            id: 'link-building',
            icon: '🔗',
            title: 'Link Building for SaaS',
            description: 'Build high-quality backlinks from relevant websites to improve your domain authority and search rankings.',
            link: '/services/seo/link-building'
        }
    ];

    return (<>

        

            <SEO 
                title="S E O Saa S Services" 
                description="Learn more about our S E O Saa S services to grow your business online with Digi Network." 
                canonical="/industries/saa-s/services/seosaa-s" 
            />

<div className="seo-services-page">
            {/* Hero Section */}
            <section className="seo-hero">
                <div className="seo-hero-bg"></div>
                <div className="container">
                    <div className="seo-hero-content">
                        
                        <h1>SEO Services for SaaS Companies</h1>
                        <p className="industry-service-hero-description">Dominate search results for software keywords, drive organic trial sign-ups, and build authority in your niche. Our SaaS-focused SEO strategies help software companies rank higher, attract qualified leads, and scale organic growth.</p>
                        <div className="industry-service-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                            Get Free SEO Audit
                            <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                            </svg>
                        </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* SaaS SEO Services Grid */}
            <section className="seo-services-grid-section">
                <div className="container">
                    <h2>Our SaaS SEO Services</h2>
                    <p>Comprehensive SEO solutions tailored for software companies</p>


                    <div className="seo-services-grid">
                        {saasSeoServices.map((service) => (
                            <Link to={service.link} key={service.id} className="seo-service-card">
                                <div className="seo-service-icon">{service.icon}</div>
                                <h3>{service.title}</h3>
                                <p>{service.description}</p>
                                <div className="learn-more">
                                    Learn More
                                    <svg width="20" height="20" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="currentColor"/>
                                    </svg>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why SaaS SEO Matters */}
            <section className="why-seo-matters">
                <div className="container">
                    <div className="why-seo-content">
                        <div className="why-seo-text">
                            <h2>Why SEO is Essential for SaaS Companies</h2>
                            <div className="why-seo-points">
                                <div className="why-point">
                                    <h4>🎯 Targeted Trial Sign-ups</h4>
                                    <p>Reach customers actively searching for software solutions like yours — qualified leads ready to start free trials.</p>
                                </div>
                                <div className="why-point">
                                    <h4>💰 Cost-Effective Growth</h4>
                                    <p>Unlike paid ads, SEO provides long-term results. Once you rank, you continue to receive organic traffic without ongoing ad spend.</p>
                                </div>
                                <div className="why-point">
                                    <h4>🏆 Authority & Trust</h4>
                                    <p>Top search rankings signal authority and trustworthiness. Users trust organic results more than paid advertisements.</p>
                                </div>
                                <div className="why-point">
                                    <h4>📈 Measurable ROI</h4>
                                    <p>Track every metric — from rankings and traffic to trial sign-ups and revenue. SEO delivers transparent, quantifiable results.</p>
                                </div>
                            </div>
                        </div>
                        <div className="why-seo-visual">
                            {/* IMAGE PLACEHOLDER: Add SaaS SEO growth chart or infographic here (recommended size: 500x600px) */}
                            <div className="seo-visual-placeholder">
                                <p>🖼️ Add SaaS SEO Impact Graphic</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Process Section */}
            <section className="seo-process">
                <div className="container">
                    <div className="section-header">
                        <div className="label">OUR APPROACH</div>
                        <h2>Our SEO Process</h2>
                        <p>A proven methodology designed specifically for saas businesses</p>
                    </div>

                    <div className="process-grid">
                        <div className="process-step">
                            <div className="process-number">01</div>
                            <h3>Comprehensive Audit</h3>
                            <p>Analyze your website, identify technical issues, and uncover growth opportunities.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">02</div>
                            <h3>Strategy Development</h3>
                            <p>Create a custom SEO roadmap aligned with your business goals and market.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">03</div>
                            <h3>Implementation</h3>
                            <p>Execute optimizations, content creation, technical fixes, and link building.</p>
                        </div>
                        <div className="process-step">
                            <div className="process-number">04</div>
                            <h3>Monitor & Optimize</h3>
                            <p>Track performance, refine strategies, and continuously improve rankings.</p>
                        </div>
                    </div>
                </div>
            </section>



            {/* CTA Section */}
            <section className="industry-service-cta">
                <div className="container">
                    <h2>Ready to Dominate Search Results for Your SaaS?</h2>
                    <p>Get a free SEO audit and discover how we can help you rank higher and drive more organic trial sign-ups.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Get Your Free SEO Audit
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
        </>
    );
};

export default SEOSaaS;
